import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

// Clean URL (/eletricista-goiania) -> static SEO page (/eletricista-goiania.html); unknown paths go home.
export default function SeoRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    let alive = true;
    fetch("/seo-pages.json")
      .then((r) => r.json())
      .then((list) => {
        if (!alive) return;
        if (Array.isArray(list) && list.includes(slug)) window.location.replace(`/${slug}.html`);
        else navigate("/", { replace: true });
      })
      .catch(() => alive && navigate("/", { replace: true }));
    return () => { alive = false; };
  }, [slug, navigate]);
  return (
    <div className="flex justify-center py-24" data-testid="seo-redirect">
      <Loader2 className="h-10 w-10 animate-spin text-orange-500" />
    </div>
  );
}
